// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2uasJ","label":"LabeledBox_label__2bal6"};